
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30084',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30084",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54243",
  "head-dlb": "static-1.4921",
  "hs-test-utils": "static-1.7906",
  "hubspot-dlb": "static-2.1828",
  "HubStyleTokens": "static-2.11346",
  "I18n": "static-7.1600",
  "quartz": "static-1.6862",
  "quartz-config": "static-1.640",
  "quartz-core": "static-1.6081",
  "react-dlb": "static-1.76",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.766",
  "enviro": "static-4.425",
  "feedback-shared-ui": "static-1.54230",
  "feedback-utils": "static-1.54234",
  "forms-embed-utils-lib": "static-1.4357",
  "forms-utils-lib": "static-1.12380",
  "foundations-assets": "static-1.4742",
  "foundations-components": "static-1.7711",
  "foundations-theming": "static-1.4308",
  "hub-http": "static-1.6114",
  "hubspot-url-utils": "static-1.4034",
  "HubStyle": "static-2.11654",
  "icons": "static-2.639",
  "immutable": "static-2.76",
  "quick-fetch": "static-1.3830",
  "raven": "static-3.5808",
  "react": "static-7.184",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.69",
  "react-rhumb": "static-1.16549",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5262",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.485",
  "tinymce-plugins": "static-1.57170",
  "transmute": "static-2.85",
  "ui-images": "static-2.1127",
  "UIComponents": "static-3.8293",
  "hs-promise-rejection-tracking": "static-1.5473",
  "PortalIdParser": "static-2.386",
  "raven-hubspot": "static-1.6115",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9522",
  "styled-components": "static-2.87",
  "bend-plugin-trellis-migration": "static-1.3320",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3139",
  "quartz-webpack": "static-1.3086",
  "foundations-theming-specialty": "static-1.2024",
  "property-description-translator": "static-1.3748",
  "HeadJS": "static-2.734",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3017",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4219",
  "jasmine-runner": "static-1.6364",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.818",
  "hubspotter-http": "static-1.4566",
  "mobile-manifest-mixins": "static-1.508",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.537",
  "quartz-head": "static-1.527",
  "quartz-i18n": "static-1.537",
  "quartz-routing": "static-1.292",
  "quartz-test": "static-1.537",
  "quartz-tracking": "static-1.241",
  "ui-fonts": "static-1.608",
  "usage-tracker-container": "static-1.7221",
  "usage-tracker-core": "static-1.7081",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.153",
  "conversations-skeleton-state": "static-1.7144",
  "reference-resolvers": "static-1.8062",
  "sanitize-text": "static-1.8040",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10269",
  "sanitize": "static-1.4368",
  "outpost": "static-1.4090",
  "rpc-client-utils": "static-1.4539",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3980",
  "floating-ui": "static-1.54",
  "hs-story-utils": "static-1.9325",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1519",
  "bend-plugin-foundations-theming": "static-1.2791",
  "foundations-theming-base": "static-1.3293",
  "stylex": "static-1.30",
  "csstype": "static-1.50",
  "ai-components-ui-library": "static-1.8668",
  "atom": "static-1.4966",
  "codemirror": "static-5.93",
  "content-assistance-lib": "static-1.7594",
  "ContentUtils": "static-1.68023",
  "data-token-picker": "static-1.16219",
  "file-manager-components": "static-1.23280",
  "FileManagerCore": "static-1.38779",
  "FileManagerLib": "static-1.38920",
  "frontend-preferences-client": "static-1.7819",
  "hub-http-contrib": "static-1.2938",
  "interframe": "static-3.4658",
  "layout-dnd-components": "static-1.12240",
  "layout-dnd-utils": "static-1.11215",
  "property-translator": "static-1.5303",
  "react-codemirror": "static-1.10518",
  "react-colorpicker": "static-2.10104",
  "reference-resolvers-lite": "static-1.7984",
  "rich-text-lib": "static-1.19649",
  "tinymce-data": "static-1.40141",
  "tinymce-themes": "static-1.56026",
  "ui-addon-emoji-picker": "static-1.9782",
  "ui-addon-sales-email": "static-1.5106",
  "ui-brand-identity-lib": "static-1.14764",
  "bender-build-tools": "static-1.3062",
  "hub-http-shared-msw-handlers": "static-1.9718",
  "hubspotter-http-shared-msw-handlers": "static-1.9716",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "usage-tracker-session-replay": "static-1.4917",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "chirp-fetch": "static-1.1776",
  "chatspot-core": "static-1.20789",
  "copilot-toolkit": "static-1.10831",
  "data-fetching-client": "static-1.9570",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4664",
  "ui-addon-video-player": "static-1.8591",
  "ui-coaching-tips": "static-1.28241",
  "usage-tracker": "static-1.7231",
  "cms-field-types": "static-1.4704",
  "content-icons-ui": "static-1.2199",
  "integrations-lib": "static-1.15766",
  "customer-data-objects": "static-1.7551",
  "apollo-dlb": "static-3.80",
  "apollo-link-hub-http": "static-2.4546",
  "apollo-stack-hubspot": "static-3.84",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "immerable": "static-1.4048",
  "ui-addon-iframeable": "static-1.8944",
  "video-components-external": "static-1.10929",
  "video-data-lib": "static-1.34587",
  "audio-components": "static-1.5757",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29100",
  "FileManagerImages": "static-1.36431",
  "foundations-components-legacy": "static-1.736",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.523",
  "ui-universal-auth": "static-1.8828",
  "urlinator": "static-1.4427",
  "video-components": "static-1.12932",
  "video-embed": "static-1.35421",
  "ts-schema": "static-1.3992",
  "ContentData": "static-1.68098",
  "layout-data-lib": "static-1.9540",
  "react-dnd-compat": "static-1.4513",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1447",
  "external-options-client-types": "static-1.4072",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6770",
  "hs-promise-utils": "static-1.5489",
  "inbound-db-properties-service-client": "static-1.3760",
  "NamespacedHubStyle": "static-2.8983",
  "growth-onboarding-confetti": "static-1.2966",
  "SharedI18nStrings": "static-1.181",
  "ui-addon-i18n": "static-1.11042",
  "amplitude-session-replay-browser": "static-1.58",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5488",
  "magpie-types": "static-1.4948",
  "simple-logging-lib": "static-1.2946",
  "growth-onboarding-feedback-components": "static-1.6477",
  "flux-actions": "static-1.325",
  "hubspot-apollo-client": "static-1.4773",
  "integrations-error-boundary-lib": "static-1.13181",
  "integrations-tracking-lib": "static-1.5490",
  "laboratory-lib": "static-3.7054",
  "native-integrations-shared-strings": "static-1.7681",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10042",
  "unified-auth": "static-1.342",
  "navigation-messaging": "static-1.6959",
  "content-media-composition-data-lib": "static-1.11885",
  "content-media-compositions": "static-2.15892",
  "idb-keyval": "static-1.42",
  "media-bridge-lib": "static-1.18739",
  "unified-auth-core-lib": "static-1.623",
  "social-insights-client-types": "static-1.21764",
  "advanced-menus-core": "static-1.14963",
  "advanced-menus-lib": "static-1.11926",
  "ExportDialog": "static-6.10286",
  "ui-memberships-settings-lib": "static-1.33748",
  "conditional-properties-service-client": "static-1.3711",
  "crm-pipelines-api-client-types": "static-1.4056",
  "framework-builder-read-service-client": "static-1.3922",
  "framework-data-schema-quick-fetch": "static-1.6675",
  "inbound-db-meta-service-client": "static-1.3503",
  "multi-currency-client-types": "static-1.3604",
  "persist-promise": "static-1.3604",
  "foundations-components-test-utils": "static-1.5194",
  "reactive-lib": "static-1.619",
  "hubspot-apollo-cache": "static-1.232",
  "universal-page-editor-lib": "static-1.2901",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3628",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14962",
  "simple-menus-lib": "static-1.16479",
  "crm-record-cards-service-types": "static-1.3524",
  "location-customization-utils-lib": "static-1.8904",
  "react-flip-move": "static-1.68"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30084",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54243",
  "head-dlb": "/head-dlb/static-1.4921",
  "hs-test-utils": "/hs-test-utils/static-1.7906",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "HubStyleTokens": "/HubStyleTokens/static-2.11346",
  "I18n": "/I18n/static-7.1600",
  "quartz": "/quartz/static-1.6862",
  "quartz-config": "/quartz-config/static-1.640",
  "quartz-core": "/quartz-core/static-1.6081",
  "react-dlb": "/react-dlb/static-1.76",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.766",
  "enviro": "/enviro/static-4.425",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54230",
  "feedback-utils": "/feedback-utils/static-1.54234",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4357",
  "forms-utils-lib": "/forms-utils-lib/static-1.12380",
  "foundations-assets": "/foundations-assets/static-1.4742",
  "foundations-components": "/foundations-components/static-1.7711",
  "foundations-theming": "/foundations-theming/static-1.4308",
  "hub-http": "/hub-http/static-1.6114",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "HubStyle": "/HubStyle/static-2.11654",
  "icons": "/icons/static-2.639",
  "immutable": "/immutable/static-2.76",
  "quick-fetch": "/quick-fetch/static-1.3830",
  "raven": "/raven/static-3.5808",
  "react": "/react/static-7.184",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.69",
  "react-rhumb": "/react-rhumb/static-1.16549",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5262",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tinymce-plugins": "/tinymce-plugins/static-1.57170",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1127",
  "UIComponents": "/UIComponents/static-3.8293",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5473",
  "PortalIdParser": "/PortalIdParser/static-2.386",
  "raven-hubspot": "/raven-hubspot/static-1.6115",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9522",
  "styled-components": "/styled-components/static-2.87",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3320",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3139",
  "quartz-webpack": "/quartz-webpack/static-1.3086",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2024",
  "property-description-translator": "/property-description-translator/static-1.3748",
  "HeadJS": "/HeadJS/static-2.734",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3017",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4219",
  "jasmine-runner": "/jasmine-runner/static-1.6364",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.818",
  "hubspotter-http": "/hubspotter-http/static-1.4566",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.508",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.537",
  "quartz-head": "/quartz-head/static-1.527",
  "quartz-i18n": "/quartz-i18n/static-1.537",
  "quartz-routing": "/quartz-routing/static-1.292",
  "quartz-test": "/quartz-test/static-1.537",
  "quartz-tracking": "/quartz-tracking/static-1.241",
  "ui-fonts": "/ui-fonts/static-1.608",
  "usage-tracker-container": "/usage-tracker-container/static-1.7221",
  "usage-tracker-core": "/usage-tracker-core/static-1.7081",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.153",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7144",
  "reference-resolvers": "/reference-resolvers/static-1.8062",
  "sanitize-text": "/sanitize-text/static-1.8040",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10269",
  "sanitize": "/sanitize/static-1.4368",
  "outpost": "/outpost/static-1.4090",
  "rpc-client-utils": "/rpc-client-utils/static-1.4539",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3980",
  "floating-ui": "/floating-ui/static-1.54",
  "hs-story-utils": "/hs-story-utils/static-1.9325",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1519",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2791",
  "foundations-theming-base": "/foundations-theming-base/static-1.3293",
  "stylex": "/stylex/static-1.30",
  "csstype": "/csstype/static-1.50",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8668",
  "atom": "/atom/static-1.4966",
  "codemirror": "/codemirror/static-5.93",
  "content-assistance-lib": "/content-assistance-lib/static-1.7594",
  "ContentUtils": "/ContentUtils/static-1.68023",
  "data-token-picker": "/data-token-picker/static-1.16219",
  "file-manager-components": "/file-manager-components/static-1.23280",
  "FileManagerCore": "/FileManagerCore/static-1.38779",
  "FileManagerLib": "/FileManagerLib/static-1.38920",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7819",
  "hub-http-contrib": "/hub-http-contrib/static-1.2938",
  "interframe": "/interframe/static-3.4658",
  "layout-dnd-components": "/layout-dnd-components/static-1.12240",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11215",
  "property-translator": "/property-translator/static-1.5303",
  "react-codemirror": "/react-codemirror/static-1.10518",
  "react-colorpicker": "/react-colorpicker/static-2.10104",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7984",
  "rich-text-lib": "/rich-text-lib/static-1.19649",
  "tinymce-data": "/tinymce-data/static-1.40141",
  "tinymce-themes": "/tinymce-themes/static-1.56026",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9782",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5106",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14764",
  "bender-build-tools": "/bender-build-tools/static-1.3062",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9718",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9716",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4917",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "chirp-fetch": "/chirp-fetch/static-1.1776",
  "chatspot-core": "/chatspot-core/static-1.20789",
  "copilot-toolkit": "/copilot-toolkit/static-1.10831",
  "data-fetching-client": "/data-fetching-client/static-1.9570",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4664",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8591",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28241",
  "usage-tracker": "/usage-tracker/static-1.7231",
  "cms-field-types": "/cms-field-types/static-1.4704",
  "content-icons-ui": "/content-icons-ui/static-1.2199",
  "integrations-lib": "/integrations-lib/static-1.15766",
  "customer-data-objects": "/customer-data-objects/static-1.7551",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4546",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4048",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8944",
  "video-components-external": "/video-components-external/static-1.10929",
  "video-data-lib": "/video-data-lib/static-1.34587",
  "audio-components": "/audio-components/static-1.5757",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29100",
  "FileManagerImages": "/FileManagerImages/static-1.36431",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.736",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.523",
  "ui-universal-auth": "/ui-universal-auth/static-1.8828",
  "urlinator": "/urlinator/static-1.4427",
  "video-components": "/video-components/static-1.12932",
  "video-embed": "/video-embed/static-1.35421",
  "ts-schema": "/ts-schema/static-1.3992",
  "ContentData": "/ContentData/static-1.68098",
  "layout-data-lib": "/layout-data-lib/static-1.9540",
  "react-dnd-compat": "/react-dnd-compat/static-1.4513",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1447",
  "external-options-client-types": "/external-options-client-types/static-1.4072",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6770",
  "hs-promise-utils": "/hs-promise-utils/static-1.5489",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3760",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8983",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2966",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11042",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5488",
  "magpie-types": "/magpie-types/static-1.4948",
  "simple-logging-lib": "/simple-logging-lib/static-1.2946",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6477",
  "flux-actions": "/flux-actions/static-1.325",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4773",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13181",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5490",
  "laboratory-lib": "/laboratory-lib/static-3.7054",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7681",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10042",
  "unified-auth": "/unified-auth/static-1.342",
  "navigation-messaging": "/navigation-messaging/static-1.6959",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11885",
  "content-media-compositions": "/content-media-compositions/static-2.15892",
  "idb-keyval": "/idb-keyval/static-1.42",
  "media-bridge-lib": "/media-bridge-lib/static-1.18739",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.623",
  "social-insights-client-types": "/social-insights-client-types/static-1.21764",
  "advanced-menus-core": "/advanced-menus-core/static-1.14963",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11926",
  "ExportDialog": "/ExportDialog/static-6.10286",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33748",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3711",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4056",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3922",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6675",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3503",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3604",
  "persist-promise": "/persist-promise/static-1.3604",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5194",
  "reactive-lib": "/reactive-lib/static-1.619",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.232",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2901",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3628",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14962",
  "simple-menus-lib": "/simple-menus-lib/static-1.16479",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3524",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8904",
  "react-flip-move": "/react-flip-move/static-1.68"
}
};
